import { useQuery } from '@tanstack/react-query';
import { parseHomeWarnings, parseSystemHealth } from '@cerebro-diem/core';
import { supabase } from './supabase';
import { queryKeys } from './queries';

/**
 * What Home warns the signed-in user about (home_warnings): reminders to come
 * with no device to receive them (CER-80), and for an owner, problems now
 * (CER-69). Re-read whenever the page is shown again.
 */
export function useHomeWarnings() {
  return useQuery({
    queryKey: queryKeys.homeWarnings,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('home_warnings');
      if (error) throw error;
      return parseHomeWarnings(data);
    },
  });
}

/** The owner's status of every scheduled job and every problem now (system_health); null for anyone else. */
export function useSystemHealth() {
  return useQuery({
    queryKey: queryKeys.systemHealth,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('system_health');
      if (error) throw error;
      return parseSystemHealth(data);
    },
  });
}
